import { render, staticRenderFns } from "./openVideoBox.vue?vue&type=template&id=3ca4ce43&scoped=true"
import script from "./openVideoBox.vue?vue&type=script&lang=js"
export * from "./openVideoBox.vue?vue&type=script&lang=js"
import style0 from "./openVideoBox.vue?vue&type=style&index=0&id=3ca4ce43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4ce43",
  null
  
)

export default component.exports